<div class="d-flex flex-wrap filter-token" *ngIf="filter_tokens?.length">
  <span *ngIf="!is_mobile" class="fw-normal filter-token__title">
    {{ 'filters' | translate }}:
  </span>

  <ng-container>
    <span
      *ngFor="let token of filter_tokens"
      class="badge bg-body me-1 border fw-normal filter-token__badge"
    >
      {{ token.value }}
      <button class="close" type="button" aria-label="Close" (click)="removeFilter(token)">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </span>
  </ng-container>

  <ng-container>
    <small>
      <a href="javascript:void(0)" (click)="clearFilters()" class="fw-normal ms-1">
        {{ 'clear_all' | translate }}
      </a>
    </small>
  </ng-container>
</div>
